import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';
import { oauth } from '@seek/oauth-url-builders';

import { getLanguagePrefixedPath } from 'src/utils/getLanguagePrefixedPath';
import { pathShouldNotRedirectToSignIn } from 'src/utils/pathShouldNotRedirectToSignIn';

import { type UserAction, UserActionType } from './actionCreators';

export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const UPDATE_USER_STATE = 'UPDATE_USER_STATE';

export interface UserDetails {
  loginId?: string;
  isLoggedIn?: boolean;
  profileGuid?: string;
}

export interface UserState {
  userId?: string;
  authenticationStatus: AUTHENTICATION_TYPES;
  firstName: string;
  lastName: string;
  emailAddress: string;
  userReady: boolean;
  accountDeleted: boolean;
  userDetails?: UserDetails | undefined;
}

const initialState: UserState = {
  authenticationStatus: AUTHENTICATION_TYPES.AUTH_PENDING,
  firstName: '',
  lastName: '',
  emailAddress: '',
  userReady: false,
  accountDeleted: false,
};

export default function reducer(
  state = initialState,
  action: UserAction,
): UserState {
  const { type, payload } = action;

  switch (type) {
    case UserActionType.SUCCESS: {
      return {
        ...state,
        userId: payload.id,
        authenticationStatus: AUTHENTICATION_TYPES.AUTHENTICATED,
        firstName: payload.personalDetails.firstName,
        lastName: payload.personalDetails.lastName,
        emailAddress: payload.emailAddress,
        userReady: true,
      };
    }

    case UserActionType.UPDATE_USER_STATE: {
      return {
        ...state,
        ...payload,
      };
    }

    case UserActionType.UPDATE_USER_STATE: {
      return {
        ...state,
        ...payload,
      };
    }

    case UserActionType.USER_DELETED: {
      const { language } = payload;
      const returnPathUrl = getLanguagePrefixedPath(
        language,
        '/account-deleted/',
      );

      const logOutUrlPart = oauth.buildLogoutUrl({
        returnPath: returnPathUrl,
        language,
      });

      const logoutUrl = `${logOutUrlPart}&returnUrl=${returnPathUrl}`;
      window.location.assign(logoutUrl);
      return state;
    }

    case UserActionType.ERROR: {
      const { language, userNotAuthenticated = true } = payload;

      const nextStepUrl = userNotAuthenticated
        ? `${oauth.buildLoginUrl({
            location: {
              origin: '',
              pathname: getLanguagePrefixedPath(language, '/settings'),
              search: '',
            },
            language,
          })}`
        : `${oauth.buildLogoutUrl({
            returnPath: getLanguagePrefixedPath(language),
            language,
          })}`;

      if (!pathShouldNotRedirectToSignIn(window.location.pathname, language)) {
        window.location.assign(nextStepUrl);
      }
      return {
        ...state,
        authenticationStatus: AUTHENTICATION_TYPES.UNAUTHENTICATED,
      };
    }

    case UserActionType.SET_USER_DETAILS: {
      return {
        ...state,
        userDetails: {
          loginId: payload.loginId,
          isLoggedIn: payload.isLoggedIn,
          profileGuid: payload.profileGuid,
        },
      };
    }

    default:
      return state;
  }
}
